import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";
import { useAdminUpdateUserPasswordMutation } from "../../store/api";
import {
  getApiErrorMessage,
  isSessionExpiredApiError,
} from "../../utils/authSession";

export default function LockOverrideModal({
  open,
  onClose,
  userId,
  userName = "",
}) {
  const [password, setPassword] = useState("");
  const [readOnly, setReadOnly] = useState(true);
  const [adminUpdateUserPassword, { isLoading }] =
    useAdminUpdateUserPasswordMutation();

  useEffect(() => {
    if (open) {
      setPassword("");
      setReadOnly(true);
    }
  }, [open]);

  async function handleSubmit() {
    if (!userId || !password.trim()) return;

    try {
      const response = await adminUpdateUserPassword({
        id: userId,
        password,
      }).unwrap();
      toast.success(response?.message || "User password updated successfully");
      onClose?.();
    } catch (error) {
      if (isSessionExpiredApiError(error)) return;
      console.error("Failed to update user password", error);
      toast.error(
        getApiErrorMessage(error) || "Failed to update user password",
      );
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[399px] !min-h-0 pt-7 pb-10 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-start justify-between mb-4 pl-9 pr-6">
          <div>
            <p className="text-xl font-bold leading-6 text-black">Lock Override</p>
            <p className=" text-sm leading-5 text-[#528FFF]">
              Assigning new credentials to {userName || "user"}
            </p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-8 px-9">
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <Input
              label="New Secure Password"
              type="password"
              name="lock-override-new-password"
              autoComplete="new-password"
              readOnly={readOnly}
              onFocus={() => setReadOnly(false)}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter New Password"
            />
          </form>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={isLoading || !password.trim()}
            className="mt-6 w-full bg-[#6D4E8A] text-white py-[10px] text-sm leading-6 rounded-[5px] flex items-center justify-center gap-2 font-bold disabled:opacity-70"
          >
            {isLoading && <Loader />}
            {isLoading ? "Processing" : "Save Changes"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
